import { SelectChangeEvent } from '@mui/material';
import { InputLabel, MenuItem } from '@mui/material';
import { RiconoscimentoGenitoreItaliano } from 'civil-status/constants/id-riconoscimento-genitore-italiano';
import { memo, useMemo } from 'react';
import { PmiSelect } from 'shell/components/shared/pmi-select';
import { PmiFormControl } from 'shell/components/shared/pmi-select/pmi-form-control';
import { __ACT_API_URL__ } from 'shell/constants/environment';
import { useHttpFetch } from 'shell/hooks/use-http-fetch';
import { ValoreDominioVO } from 'shell/models/act-wizard';
import { HttpResponse } from 'shell/models/http-response';
import { ItemVM } from 'shell/view-models/item';

interface ListParentRecognitionProps {
  disabled?: boolean;
  required?: boolean;
  value: string;
  onChange: (value: SelectChangeEvent<string>) => void;
  error?: boolean;
  isSmallSize?: boolean;
  label?: string;
  withoutEntrambi?: boolean;
}

const ListParentRecognitionComponent = ({
  disabled,
  required,
  onChange,
  value,
  error,
  isSmallSize = false,
  withoutEntrambi = false,
  label = 'Riconoscimento da genitore italiano',
}: ListParentRecognitionProps): React.ReactElement => {
  const [parents] = useHttpFetch<HttpResponse<Array<ValoreDominioVO>>, Array<ItemVM>>(
    `${__ACT_API_URL__}/filtri/dominio/42`,
    {
      onBootstrap: true,
      options: {
        errorCatching: true,
        method: 'GET',
        loading: true,
      },
      transformer: (response) => {
        let castedRes = (response.data.payload || []) as Array<ValoreDominioVO>;

        if (withoutEntrambi) {
          castedRes = castedRes.filter(
            (item) => item.key?.idValore !== RiconoscimentoGenitoreItaliano.Entrambi
          );
        }

        return castedRes.map((item) => ({
          id: item.key?.idValore?.toString(),
          value: item.descrizioneValore,
        })) as Array<ItemVM>;
      },
    }
  );

  const parentsData: Array<ItemVM> = useMemo(() => {
    return (parents.data || []) as Array<ItemVM>;
  }, [parents.data]);

  return (
    <PmiFormControl fullWidth>
      <InputLabel error={error} disabled={disabled} id="parent-label">
        {required ? `${label} *` : label}
      </InputLabel>
      <PmiSelect
        labelId="parent-label"
        id="parent"
        name="parent"
        value={value}
        label={required ? `${label} *` : label}
        onChange={onChange}
        disabled={disabled}
        error={error}
        size={isSmallSize ? 'small' : undefined}
      >
        {parentsData?.map((parent: ItemVM) => (
          <MenuItem key={parent.id} value={parent.id}>
            {parent.value}
          </MenuItem>
        ))}
      </PmiSelect>
    </PmiFormControl>
  );
};

ListParentRecognitionComponent.displayName = 'List Parent Recognition component';

const ListParentRecognition = memo(ListParentRecognitionComponent);

export default ListParentRecognition as typeof ListParentRecognitionComponent;
